export const SupportedChainId = {
  ETHEREUM: 1,
  AVALANCHE: 43114,
  OPTIMISM: 10,
  ARBITRUM: 42161,
  BASE: 8453,
  POLYGON: 137,
  UNICHAIN: 130,
  LINEA: 59144,
  SONIC: 146,
};

export const CHAIN_TO_CHAIN_NAME = {
  [SupportedChainId.ETHEREUM]: 'Ethereum',
  [SupportedChainId.AVALANCHE]: 'Avalanche',
  [SupportedChainId.OPTIMISM]: 'Optimism',
  [SupportedChainId.ARBITRUM]: 'Arbitrum',
  [SupportedChainId.BASE]: 'Base',
  [SupportedChainId.POLYGON]: 'Polygon',
  [SupportedChainId.UNICHAIN]: 'Unichain',
  [SupportedChainId.LINEA]: 'Linea',
  [SupportedChainId.SONIC]: 'Sonic',
};

// IMPORTANT: These are the native USDC addresses supported by CCTP
// Not USDC.e or other bridged versions
export const CHAIN_IDS_TO_USDC_ADDRESSES = {
  [SupportedChainId.ETHEREUM]: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
  [SupportedChainId.AVALANCHE]: '0xB97EF9Ef8734C71904D8002F8b6Bc66Dd9c48a6E',
  [SupportedChainId.OPTIMISM]: '0x0b2C639c533813f4Aa9D7837CAf62653d097Ff85',
  [SupportedChainId.ARBITRUM]: '0xaf88d065e77c8cC2239327C5EDb3A432268e5831',
  [SupportedChainId.BASE]: '0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913',
  [SupportedChainId.POLYGON]: '0x3c499c542cEF5E3811e1192ce70d8cC03d5c3359', // Native USDC on Polygon PoS
  [SupportedChainId.UNICHAIN]: '0x078D782b760474a361dDA0AF3839290b0EF57AD6', // Native USDC on Unichain
  [SupportedChainId.LINEA]: '0x176211869cA2b568f2A7D4EE941E073a821EE1ff', // Native USDC on Linea
  [SupportedChainId.SONIC]: '0x29219dd400f2Bf60E5a23d13Be72B486D4038894', // Native USDC on Sonic
};

// TokenMessenger V2 addresses - same for all chains
export const CHAIN_IDS_TO_TOKEN_MESSENGER = {
  [SupportedChainId.ETHEREUM]: '0x28b5a0e9C621a5BadaA536219b3a228C8168cf5d',
  [SupportedChainId.AVALANCHE]: '0x28b5a0e9C621a5BadaA536219b3a228C8168cf5d',
  [SupportedChainId.OPTIMISM]: '0x28b5a0e9C621a5BadaA536219b3a228C8168cf5d',
  [SupportedChainId.ARBITRUM]: '0x28b5a0e9C621a5BadaA536219b3a228C8168cf5d',
  [SupportedChainId.BASE]: '0x28b5a0e9C621a5BadaA536219b3a228C8168cf5d',
  [SupportedChainId.POLYGON]: '0x28b5a0e9C621a5BadaA536219b3a228C8168cf5d', // TokenMessenger V2 on Polygon
  [SupportedChainId.UNICHAIN]: '0x28b5a0e9C621a5BadaA536219b3a228C8168cf5d', // TokenMessenger V2 on Unichain
  [SupportedChainId.LINEA]: '0x28b5a0e9C621a5BadaA536219b3a228C8168cf5d', // TokenMessenger V2 on Linea
  [SupportedChainId.SONIC]: '0x28b5a0e9C621a5BadaA536219b3a228C8168cf5d', // TokenMessenger V2 on Sonic
};

// MessageTransmitter V2 addresses - same for all chains
export const CHAIN_IDS_TO_MESSAGE_TRANSMITTER = {
  [SupportedChainId.ETHEREUM]: '0x81D40F21F12A8F0E3252Bccb954D722d4c464B64',
  [SupportedChainId.AVALANCHE]: '0x81D40F21F12A8F0E3252Bccb954D722d4c464B64',
  [SupportedChainId.OPTIMISM]: '0x81D40F21F12A8F0E3252Bccb954D722d4c464B64',
  [SupportedChainId.ARBITRUM]: '0x81D40F21F12A8F0E3252Bccb954D722d4c464B64',
  [SupportedChainId.BASE]: '0x81D40F21F12A8F0E3252Bccb954D722d4c464B64',
  [SupportedChainId.POLYGON]: '0x81D40F21F12A8F0E3252Bccb954D722d4c464B64', // MessageTransmitter V2 on Polygon
  [SupportedChainId.UNICHAIN]: '0x81D40F21F12A8F0E3252Bccb954D722d4c464B64', // MessageTransmitter V2 on Unichain
  [SupportedChainId.LINEA]: '0x81D40F21F12A8F0E3252Bccb954D722d4c464B64', // MessageTransmitter V2 on Linea
  [SupportedChainId.SONIC]: '0x81D40F21F12A8F0E3252Bccb954D722d4c464B64', // MessageTransmitter V2 on Sonic
};

export const DESTINATION_DOMAINS = {
  [SupportedChainId.ETHEREUM]: 0,
  [SupportedChainId.AVALANCHE]: 1,
  [SupportedChainId.OPTIMISM]: 2,
  [SupportedChainId.ARBITRUM]: 3,
  [SupportedChainId.BASE]: 6,
  [SupportedChainId.POLYGON]: 7,
  [SupportedChainId.UNICHAIN]: 10,
  [SupportedChainId.LINEA]: 11,
  [SupportedChainId.SONIC]: 13,
};

export const SUPPORTED_CHAINS = [
  SupportedChainId.ETHEREUM,
  SupportedChainId.AVALANCHE,
  SupportedChainId.OPTIMISM,
  SupportedChainId.ARBITRUM,
  SupportedChainId.BASE,
  SupportedChainId.POLYGON,
  SupportedChainId.UNICHAIN,
  SupportedChainId.LINEA,
  SupportedChainId.SONIC,
];

export const IRIS_API_URL = 'https://iris-api.circle.com';

export const CHAIN_RPC_URLS = {
  [SupportedChainId.ETHEREUM]: `https://lb.drpc.org/ethereum/AllMzvTCtkaEj28yNral-Nsr3cKX_G4R75_AnqSgS7QB`,
  [SupportedChainId.AVALANCHE]: 'https://lb.drpc.org/avalanche/AllMzvTCtkaEj28yNral-Nsr3cKX_G4R75_AnqSgS7QB',
  [SupportedChainId.OPTIMISM]: `https://lb.drpc.org/optimism/AllMzvTCtkaEj28yNral-Nsr3cKX_G4R75_AnqSgS7QB`,
  [SupportedChainId.ARBITRUM]: `https://lb.drpc.org/arbitrum/AllMzvTCtkaEj28yNral-Nsr3cKX_G4R75_AnqSgS7QB`,
  [SupportedChainId.BASE]: `https://lb.drpc.org/base/AllMzvTCtkaEj28yNral-Nsr3cKX_G4R75_AnqSgS7QB`,
  [SupportedChainId.POLYGON]: `https://lb.drpc.org/polygon/AllMzvTCtkaEj28yNral-Nsr3cKX_G4R75_AnqSgS7QB`,
  [SupportedChainId.UNICHAIN]: `https://lb.drpc.org/unichain/AllMzvTCtkaEj28yNral-Nsr3cKX_G4R75_AnqSgS7QB`,
  [SupportedChainId.LINEA]: 'https://lb.drpc.org/linea/AllMzvTCtkaEj28yNral-Nsr3cKX_G4R75_AnqSgS7QB',
  [SupportedChainId.SONIC]: 'https://lb.drpc.org/sonic/AllMzvTCtkaEj28yNral-Nsr3cKX_G4R75_AnqSgS7QB',
};

export const EXPLORER_URLS = {
  [SupportedChainId.ETHEREUM]: 'https://etherscan.io/',
  [SupportedChainId.AVALANCHE]: 'https://snowtrace.io/',
  [SupportedChainId.OPTIMISM]: `https://optimistic.etherscan.io/`,
  [SupportedChainId.ARBITRUM]: `https://arbiscan.io/`,
  [SupportedChainId.BASE]: `https://basescan.org/`,
  [SupportedChainId.POLYGON]: `https://polygonscan.com/`,
  [SupportedChainId.UNICHAIN]: `https://unichain.blockscout.com/`,
  [SupportedChainId.LINEA]: 'https://lineascan.build/',
  [SupportedChainId.SONIC]: 'https://sonicscan.org/',
};
